import { render, staticRenderFns } from "./StoragePO_detail.vue?vue&type=template&id=0c31fed8&scoped=true&"
import script from "./StoragePO_detail.vue?vue&type=script&lang=js&"
export * from "./StoragePO_detail.vue?vue&type=script&lang=js&"
import style0 from "./StoragePO_detail.vue?vue&type=style&index=0&id=0c31fed8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c31fed8",
  null
  
)

export default component.exports